import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import ScheduleTemplateInfoForm from 'components/Schedule/ScheduleTemplateInfoForm'
import { setRequiredPositions } from 'store/actions/scheduleTemplates'
import { closeModal } from 'store/actions/modals'
import { Loading } from 'components/UI'
import { t } from 'translations'

const ScheduleTemplateInfoModal = ({ scheduleTemplateId }) => {
  const dispatch = useDispatch()
  const [template, setTemplate] = useState()
  const [errorLoading, setErrorLoading] = useState(false)

  useEffect(() => {
    const fetchScheduleTemplate = async () => {
      const { result, success } = await Api(`schedule/template`, { params: { _id: scheduleTemplateId, useNewReturn: true } })
      if (!success || !result.length) return setErrorLoading(true)
      return setTemplate(result[0])
    }

    fetchScheduleTemplate()
  }, [scheduleTemplateId])

  const onSubmit = async (
    {
      name,
      comment,
      projects,
      team,
      requiredPositions,
      defaultShiftComment,
      defaultShiftTags,
      combineShiftAndTemplateTags,
      departments,
      allShiftsIrreplaceable
    },
    actions
  ) => {
    try {
      const { success } = await Api.put(`schedule/template`, {
        _id: scheduleTemplateId,
        name,
        comment,
        projects,
        team,
        requiredPositions,
        defaultShiftComment,
        defaultShiftTags,
        combineShiftAndTemplateTags,
        departments,
        allShiftsIrreplaceable
      })
      if (!success) throw new Error('Error saving template')
      dispatch(setRequiredPositions(requiredPositions))
      dispatch(closeModal())
    } catch (error) {
      actions.setStatus({ type: 'danger', msg: 'manager.scheduleTemplates.TEMPLATE_INFO_MODAL.ERROR_SAVING' })
      actions.setSubmitting(false)
    }
  }

  if (errorLoading) return <BaseModal title={`manager.scheduleTemplates.TEMPLATE_INFO_MODAL`}>{t('manager.scheduleTemplates.TEMPLATE_DELETED')}</BaseModal>
  if (!template) return <Loading />

  return (
    <BaseModal hideButtons title={`manager.scheduleTemplates.TEMPLATE_INFO_MODAL`}>
      <ScheduleTemplateInfoForm template={template} onSubmit={onSubmit} inModal />
    </BaseModal>
  )
}

export default ScheduleTemplateInfoModal
